var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1734327890682,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 17293,
    width: 32,
    height: 32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M988.595745 624.340426a34.042553 34.042553 0 0 0-34.042554 34.042553V953.191489H69.446809V658.382979a34.042553 34.042553 0 0 0-68.085107 0v331.574468a34.042553 34.042553 0 0 0 34.042553 34.042553h953.19149a34.042553 34.042553 0 0 0 34.042553-34.042553V658.382979a34.042553 34.042553 0 0 0-34.042553-34.042553z",
    fill: "#076a09",
    "p-id": 17294
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M488.170213 792.510638a34.042553 34.042553 0 0 0 48.340425 0l151.829788-151.829787a34.042553 34.042553 0 1 0-48.340426-48.340425L546.042553 686.297872V34.042553a34.042553 34.042553 0 0 0-68.085106 0v652.255319L384 593.021277a34.042553 34.042553 0 0 0-48.340426 48.340425z",
    fill: "#076a09",
    "p-id": 17295
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/下载.c51565de23b78d4415192a47bca7b1f9.svg";
export { ForwardRef as ReactComponent };